import styled from 'styled-components';

import Spinner from 'react-spinners/ClipLoader';

interface ButtonProps {
  widthMode?: 'expand' | 'fit-content';
  size?: 'small' | 'default' | 'extra-small';
  danger?: boolean;
}

interface LoaderProps {
  danger?: boolean;
}

export const Container = styled.button<ButtonProps>`
  width: ${(props) =>
    props.widthMode === 'fit-content' ? 'fit-content' : '100%'};
  padding: ${(props) =>
    props.size === 'extra-small' ? '8px 10px' : '10px 15px'};
  font-size: ${(props) =>
    props.size === 'small' ? 12 : props.size === 'extra-small' ? 11 : 14}px;
  background-color: ${(props) =>
    props.danger ? props.theme.colors.red : props.theme.colors.primary};
  transition: all 0.2s ease-in-out;
  border: none;
  cursor: pointer;
  color: white;
  border-radius: 3px;
  font-weight: bold;
  position: relative;
  overflow: hidden;
  gap: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${(props) =>
      props.danger
        ? props.theme.colors.redHover
        : props.theme.colors.primaryHover};
  }
`;

export const Loader = styled.div<LoaderProps>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) =>
    props.danger ? props.theme.colors.red : props.theme.colors.primary};
`;

export const Loading = styled(Spinner).attrs((props) => ({
  size: 18,
  color: props.theme.colors.white,
}))``;
